import { lazy } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";

import { paths } from "../utils/routes/paths";

export const AppLaunch = lazy(
  () => import("../components/launch/app-launch/AppLaunch")
);

// ---------------------------------------------------------------------------
// SECURITY MITIGATION — ADO bugs 5454707 (AuthenticationBypass) + 5454708 (Other)
//
// The /launchAppContinue and /launchAppContinueAAD OAuth callback handlers
// trust an attacker-controllable `serviceBaseUrl` URL query parameter and
// persist it to sessionStorage without allowlist validation. That value is
// then used verbatim as the Apollo HttpLink `uri`, causing the OAuth
// `code`+`state` (and every subsequent GraphQL operation in the tab) to be
// POSTed to whatever origin the URL specifies. See AppLaunchContinue.tsx:35
// and AppLaunchAadContinue.tsx:31. Bug 5454708 is a scanner-confirmed
// duplicate of 5454707 (same line, two scanner agents).
//
// Because the Cerner client app is NOT yet live for customers, the chosen
// short-term mitigation is to comment out the vulnerable routes (and their
// lazy imports + wrapper functions) so the handlers become completely
// unreachable. The wildcard route `path="*"` below absorbs any URL that
// previously matched these paths.
//
// BEFORE RE-ENABLING THESE ROUTES (required before Cerner GA), the team
// MUST land a proper fix mirroring the allowlist used by sibling apps:
//   - apps/device-tester-client/src/apollo/apollo-links/utils/endpointHelper.ts
//   - apps/ehr-connector/config-app/src/apollo/apollo-endpoint-provider/endpoint-helper.ts
// Specifically: introduce ALLOWED_CERNER_ENDPOINTS in environment.*.ts and
// wrap setServiceBaseUrl() in both Continue components with a
// getValidatedEndpoint() call, plus add a CSP connect-src restriction.
// ---------------------------------------------------------------------------
// export const AppLaunchContinue = lazy(
//   () => import("../components/launch/app-launch-continue/AppLaunchContinue")
// );

// export const AppLaunchAadContinue = lazy(
//   () =>
//     import("../components/launch/app-launch-aad-continue/AppLaunchAadContinue")
// );

export const ConnectedAppointmentView = lazy(
  () =>
    import(
      "../components/appointment/appointment-view/ConnectedAppointmentView"
    )
);

export const GlobalError = lazy(
  () => import("../components/errors/global-error/GlobalError")
);

export const RouteSwitcher = (): JSX.Element => {
  const { t } = useTranslation();
  const Launch = () => {
    document.title = t("Connect to Microsoft Teams");
    return <AppLaunch />;
  };
  // SECURITY MITIGATION (ADO bugs 5454707 + 5454708) — see block comment above.
  // const LaunchAppContinue = () => {
  //   document.title = t("Connect to Microsoft Teams");
  //   return <AppLaunchContinue />;
  // };
  // const LaunchAppContinueAAD = () => {
  //   document.title = t("Connect to Microsoft Teams");
  //   return <AppLaunchAadContinue />;
  // };
  const Error = () => {
    document.title = t("Connect to Microsoft Teams");
    return <GlobalError />;
  };
  const Root = () => {
    document.title = t("Connect to Microsoft Teams");
    return <ConnectedAppointmentView />;
  };
  return (
    <Routes>
      <Route path={paths.launch} element={<Launch />} />
      {/* SECURITY MITIGATION (ADO bugs 5454707 + 5454708) — see block comment above. */}
      {/* <Route path={paths.launchAppContinue} element={<LaunchAppContinue />} /> */}
      {/* <Route
        path={paths.launchAppContinueAAD}
        element={<LaunchAppContinueAAD />}
      /> */}
      <Route path={paths.error} element={<Error />} />
      <Route path="*" element={<Root />} />
    </Routes>
  );
};
